(() => {
  if (window.clutchCollectionCardInitialized) return;
  window.clutchCollectionCardInitialized = true;

  const clampQuantity = (input) => {
    if (!input) return;

    const min = Number.parseInt(input.min || '1', 10);
    const parsedMax = Number.parseInt(input.max || '', 10);
    const max = Number.isFinite(parsedMax) ? parsedMax : Infinity;

    let value = Number.parseInt(input.value || String(min), 10);

    if (!Number.isFinite(value)) {
      value = min;
    }

    input.value = String(Math.min(Math.max(value, min), max));

    const wrapper = input.closest('[data-clutch-quantity]');
    if (!wrapper) return;

    const minusButton = wrapper.querySelector('[data-clutch-minus]');
    const plusButton = wrapper.querySelector('[data-clutch-plus]');

    if (minusButton) {
      minusButton.disabled = Number(input.value) <= min;
    }

    if (plusButton) {
      plusButton.disabled = Number(input.value) >= max;
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(
      '[data-clutch-minus], [data-clutch-plus]'
    );

    if (!button) return;

    const wrapper = button.closest('[data-clutch-quantity]');
    const input = wrapper?.querySelector('.clutch-card-quantity__input');

    if (!input) return;

    const direction = button.hasAttribute('data-clutch-plus') ? 1 : -1;
    const currentValue = Number.parseInt(input.value || '1', 10);

    input.value = String(currentValue + direction);

    clampQuantity(input);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('input', (event) => {
    if (!event.target.matches('.clutch-card-quantity__input')) return;

    clampQuantity(event.target);
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest(
      '[data-clutch-condition-select]'
    );

    if (!select) return;

    const form = select.closest('form');
    const selectedOption = select.options[select.selectedIndex];

    const variantInput = form?.querySelector(
      '.clutch-card-variant-id'
    );

    const price = form?.querySelector(
      '.clutch-selected-price'
    );

    const quantityInput = form?.querySelector(
      '.clutch-card-quantity__input'
    );

    const submitButton = form?.querySelector(
      '[name="add"]'
    );

    const isAvailable =
      selectedOption.dataset.available === 'true';

    if (variantInput) {
      variantInput.value = selectedOption.value;
      variantInput.disabled = !isAvailable;
    }

    if (price && selectedOption.dataset.price) {
      price.textContent = selectedOption.dataset.price;
    }

    if (quantityInput) {
      const inventoryMaximum = Number.parseInt(
        selectedOption.dataset.max || '',
        10
      );

      if (
        Number.isFinite(inventoryMaximum) &&
        inventoryMaximum >= 0
      ) {
        quantityInput.max = String(inventoryMaximum);
      } else {
        quantityInput.removeAttribute('max');
      }

      quantityInput.value = '1';
      clampQuantity(quantityInput);
    }

    if (submitButton) {
      submitButton.disabled = !isAvailable;
    }
  });

  document
    .querySelectorAll('.clutch-card-quantity__input')
    .forEach(clampQuantity);
})();